import React from "react";
import { format } from "date-fns";
// import { useTranslation } from 'react-i18next';

export const isClassBlock = text =>
  text && text.length > 40 ? "_block" : null;

export const printInfo = (
  data,
  text,
  isPhoneNumber = false,
  isAddress = false
) => {
  // const [t] = useTranslation();
  console.log("printInfo data,isAddress",data,isAddress);
  if (isAddress) {
    console.log("isAddress,data address",isAddress, data);
    const delimiter = data.includes("\n") ? /\n+/ : /,\s*/;
    const parts = data
      .split(delimiter)
      .map(l => l.trim())
      .filter(Boolean);
    return (
      <div className="b-entity-info__row">
        <strong className={isClassBlock(text + data)}>{text}</strong>
        <span className="multiline">
          {parts.map((p, i) => (
            <React.Fragment key={i}>
              {p}
              {i < parts.length - 1 && <br />}
            </React.Fragment>
          ))}
        </span>
      </div>
    );
  }
  return data && data.length ? (
    <div className="b-entity-info__row">
      <strong className={isClassBlock(text + data)}>{text}</strong>
      {isPhoneNumber ? (
        <a className="phone-number" href={`tel:+${data}`}>
          {Array.isArray(data) ? data.join(", ") : data}
        </a>
      ) : (
        <span>{Array.isArray(data) ? data.join(", ") : data}</span>
      )}
    </div>
  ) : null;
};

export const getEventDates = (startDate, endDate, getDateWithOffset) => {
  if (!startDate || !endDate) return undefined;

  const formatDate = date => format(getDateWithOffset(date), "dd.MM.yyyy");

  return `${formatDate(startDate)}${
    startDate !== endDate ? ` — ${formatDate(endDate)}` : ""
  }`;
};
